import { Button, type EmptyStateSettings, Table, type TableColumns } from '@bp/ui-components';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { ProcuratOrganization } from '../hooks/useProcuratGroups';

type ProcuratOrganizationTableProps = {
  data: ProcuratOrganization[];
  onSetup: (procuratOrgaId: string) => void;
};
export const ProcuratOrganizationTable = ({ onSetup, data }: ProcuratOrganizationTableProps) => {
  const { t } = useTranslation();

  const orgaColumns: TableColumns<ProcuratOrganization>[] = useMemo(() => {
    return [
      {
        id: 'id',
        accessorKey: 'id',
        header: 'ID',
        size: 300,
      },
      {
        header: t('common.name'),
        id: 'name',
        accessorKey: 'name',
        size: 500,
        canExpand: true,
      },
      {
        id: 'active',
        accessorKey: 'current',
        header: t('common.status'),
        type: 'boolean',
        size: 150,
      },
    ];
  }, [t]);

  const emptyStateSettings: EmptyStateSettings = {
    hideIcon: true,
    title: t('persons.noOrganizations'),
    padding: 's',
  };

  return (
    <Table<ProcuratOrganization>
      columns={orgaColumns}
      data={data ?? []}
      emptyStateSettings={emptyStateSettings}
      customPadding='var(--spacing-7)'
      lastColWidth={'100px'}
      lastCol={(row) => (
        <>
          <Button hierarchy={'secondary'} onClick={() => onSetup(row.original.id)}>
            {t('common.activate')}
          </Button>
        </>
      )}
    />
  );
};
